import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.05577 4.43598H23V1.50752H6.06768L5.05577 4.43598ZM5.00883 1.50752L3.99692 4.43598H1V1.50752H5.00883ZM5.70066 0.500137H0.841C0.375976 0.500137 0 0.879656 0 1.34734V4.59615C0 5.06473 0.375858 5.44336 0.841 5.44336H1.6322V16.1904C1.6322 16.9136 2.21481 17.5 2.9322 17.5H7.5654H16.4344H21.0672C21.7846 17.5 22.3672 16.9136 22.3672 16.1904V5.44336H23.159C23.6233 5.44336 24 5.06461 24 4.59615V1.34734C24 0.879777 23.6231 0.500137 23.159 0.500137H5.72391C5.71614 0.499954 5.70839 0.499955 5.70066 0.500137ZM16.9344 16.4926H21.0672C21.2325 16.4926 21.3672 16.357 21.3672 16.1904V5.44366H2.6322V16.1904C2.6322 16.357 2.7669 16.4926 2.9322 16.4926H7.0654V8.53028C7.0654 8.14023 7.3793 7.82511 7.7654 7.82511H11.9772C11.9847 7.82477 11.9922 7.82461 11.9998 7.82461C12.0074 7.82461 12.0149 7.82477 12.0224 7.82511H16.2344C16.6205 7.82511 16.9344 8.14023 16.9344 8.53028V16.4926ZM8.0654 8.83249H11.4998V16.4926H8.0654V8.83249ZM15.9344 16.4926H12.4998V8.83249H15.9344V16.4926Z"
      />
    </svg>
  );
}
